exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputIsentoChecked[data-v-2b3257d8]{background-color:#ede56a}", ""]);

// exports
